import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { Helmet } from 'react-helmet';

export default function SEO({ title = "Creator Pro", update }) {
    const [tabTitle, setTabTitle] = useState(title)
    const [tabDescription, setTabDescription] = useState("Media kit shows the overall analytics of the creator.")
    const consumerDetails = useSelector((state) => state.consumerDetails)
    useEffect(() => {
        const pathName = window.location.pathname
        if (pathName === "/") {
            setTabTitle(title)
        } else if (pathName === "/social-performance" || pathName.includes("/media-kit/")) {
            setTabTitle("Media Kit | Creator Pro")
        } else if (!_.isEmpty(consumerDetails)) {
            setTabTitle(`${consumerDetails.store_name} | Creator Pro`)
            setTabDescription(consumerDetails?.description.trim())
        } else {
            const name = window.location.pathname.replace("/", "")
            setTabTitle(`${capitalizeFirstLetter(name)} | Creator Pro`)
        }
    }, [update, consumerDetails])
    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    const structuredData = useMemo(() => {
        return {
            "@context": "https://schema.org",
            "@graph": [
                {
                    "@type": "Organization",
                    "name": "Creator Pro",
                    "url": window?.location?.origin,
                    "sameAs": [
                        "https://www.facebook.com/JoshAppIndia",
                        "https://www.instagram.com/officialjoshapp/",
                        "https://twitter.com/OfficialJoshApp"
                    ],
                    "mainEntityOfPage": {
                        "@type": "Website",
                        "@id": `${window?.location?.origin}/#webpage`,
                        "url": window?.location?.origin
                    },
                    "headline": tabTitle,
                    "description": tabDescription
                },
                {
                    "@type": "WebPage",
                    "@id": `${window?.location?.href}/#webpage`,
                    "url": window?.location?.href,
                    "name": tabTitle,
                    "isPartOf": {
                        "@id": window?.location?.origin
                    },
                    "description": tabDescription,
                    "inLanguage": "en-US"
                }
            ]
        }
    }, [update, consumerDetails, tabDescription, tabTitle])

    return (
        <Helmet>
            <meta charSet="utf-8" />
            <link rel="canonical" href={window?.location?.href} />
            <title>{tabTitle || "Creator Pro"}</title>
            <meta name="description" content={tabDescription || "Media kit shows the overall analytics of the creator."} />
            <meta name="title" content={tabTitle || "Creator Pro"} />
            <meta property="og:title" content={tabTitle || "Creator Pro"} />
            <meta property="og:description" content={tabDescription || "Media kit shows the overall analytics of the creator."} />
            <meta property="og:image:type" content='image/png' />
            <meta property="og:image" itemprop="image" content={window?.location?.origin + '/joshfav.png'} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={window?.location?.href} />
            <meta name='twitter:card' content={tabTitle || "Creator Pro"} />
            <meta name="twitter:title" content={tabTitle || "Creator Pro"} />
            <meta name='twitter:description' content={tabDescription || "Media kit shows the overall analytics of the creator."} />
            <meta property="twitter:image" content={window?.location?.origin + '/joshfav.png'} />
            <meta property="twitter:site" content={window?.location?.href} />
            <meta property="twitter:creator" content="@Josh" />
            <meta name='robots' content="index" />
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
        </Helmet>
    )
}